import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { FormProvider, useForm } from "react-hook-form"
import { UFInput } from "../../../components/Common/Fields/Input"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchHrmsLeaveType,
  fetchLeaveTypeEdit,
  postHrmsLeaveType,
  updateLeaveTypeStatus,
} from "../../../services/Hrms/hrms"
import HrmsSearch from "../search"
import { useSelector } from "react-redux"
import { capitalize } from "lodash"
import { getCode } from "../../../services/inventory"
import { useLocation } from "react-router-dom"

const schema = yup.object().shape({
  // leave_code: yup.string().required("Leave Code is Required"),

  name: yup.string().required("Name is Required"),
  // default_days: yup
  //   .number()
  //   .typeError("Leave Days must be a number")
  //   .integer("Leave Days must be an integer")
  //   .min(0, "Leave Days cannot be negative")
  //   .nullable()
  //   .transform(value => (isNaN(value) ? undefined : value)),
})
const LeaveType = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Leave Types${companyname ? ` | ${companyname}` : "MEP -Hub"
    }`

  const loggedUser = useSelector(state => state.Login.loggedUser)

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      name: "",
    },
  })
  const [isLoading, setIsLoading] = useState(false)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [page, setPage] = useState("")

  const [listData, setListData] = useState()
  const [count, setCount] = useState(0)
  const [search, setSearch] = useState("")
  const [editData, setEditData] = useState("")
  const [ptt, setPtt] = useState(false)
  const [finacialCheck, setfinacialCheck] = useState(true)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchHrmsLeaveType({
        params: `${search ? `&searchText=${search}` : "&searchText"}${page ? `&page=${page}` : ""
          }${`&sortOrder=asc`}${`&financial=${finacialCheck}`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setListData(response)
      const newData = response?.data?.data || [];

      setListData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }

    const getUniqueCode = async (code, modal, type) => {
      const response = await getCode(code, modal, type)
      console.log(`response`, response)
      if (ptt == false) {
        setValue("code", response?.code?.code)
      }
      setValue("code_edit", response?.code?.manualoverride)
    }
    getUniqueCode("code", "LeaveType", "Leave Type")

    fetchData()
  }, [count, search, page, finacialCheck, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < listData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [listData, page]);

  useEffect(() => {
    if (editData.id) {
      reset({ ...editData })
    }
  }, [editData.id])

  const handleFormSubmit = async data => {
    try {
      setIsLoading(true)
      const createdSeries = await postHrmsLeaveType({
        ...data,
        default_days: data?.default_days ? data?.default_days : 0,
      })
      setPtt(false)
      toastSuccess(createdSeries?.message)
      reset({
        // leave_code: "",
        name: "",
      })
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      setEditData("")
    }
  }

  const handleEdit = async item => {
    const response = await fetchLeaveTypeEdit(item)
    setEditData(response?.data)
    setPtt(true)
  }

  const handleStatus = async id => {
    try {
      const response = await updateLeaveTypeStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    {
      label: "Leave Code",
      renderCell: item => item?.code,
    },
    {
      label: "Description",
      renderCell: item => (item?.name ? capitalize(item?.name) : "-"),
      sortKey: "name",
    },
    {
      label: "Days",
      renderCell: item => (item?.default_days ? item?.default_days : 0),
      sortKey: "default_days",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 && (
                <div
                  className="table-popup-content"
                  onClick={() => handleEdit(item?.id)}
                >
                  Edit
                </div>
              )}
              <div
                className={`${item?.status === 1 ? "popover-border" : ""
                  } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCancel = () => {
    reset({
      // leave_code: "",
      name: "",
    })
    setEditData("")
  }

  const handleFinacialCheck = dt => {
    setfinacialCheck(!dt)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="HRMS"
              breadcrumbObject={[
                { title: "HRMS", link: "/hrms" },
                { title: crumb || "Masters", link: "/hrms" },
                { title: "Leave Types", link: "/hrms-religion" },
              ]}
            />
          </div>

          <Row className="mt-2">
            <Col xs={5}>
              <Card className="me-2 px-2 pb-2 input-card">
                <div className="input-card-head edittheamtitle">
                  {editData?.id ? "Edit" : "Add"}
                </div>
                <hr className="table-divide" />
                <FormProvider {...methods}>
                  <Form
                    id={`ev-form`}
                    onSubmit={handleSubmit(handleFormSubmit)}
                  >
                    <Row className="mt-2">
                      <Col sm={12}>
                        <FormGroup className="mb-4">
                          <Label>Code</Label>
                          <UFInput
                            control={control}
                            placeholder=""
                            name={"code"}
                            invalid={!!errors.estimation_code}
                            disabled={
                              watch("code_edit") == 0 ||
                                watch("code_edit") == undefined
                                ? true
                                : false
                            }
                          />
                          <FormFeedback invalid>
                            {errors.estimation_code?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={12}>
                        <FormGroup className="mb-4">
                          <Label>
                            Name<span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter the Name"
                            name={"name"}
                            invalid={!!errors.name}
                          />
                          <FormFeedback invalid>
                            {errors.name?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={12}>
                        <FormGroup className="mb-4">
                          <Label>Leave Days</Label>
                          <UFInput
                            control={control}
                            placeholder="Enter the Leave Days"
                            name={"default_days"}
                            invalid={!!errors.default_days}
                            type="number"
                          />
                          <FormFeedback invalid>
                            {errors.default_days?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={12}>
                        <div className="float-end">
                          <Button
                            className="btn-secondary me-2"
                            form={`ev-form`}
                            color={"secondary"}
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                          <LoadingButton
                            form={`ev-form`}
                            color={"primary"}
                            loading={isLoading}
                            disabled={isLoading}
                            type="submit"
                          >
                            {editData?.id ? "Update" : "Create"}
                          </LoadingButton>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </FormProvider>
              </Card>
            </Col>
            <Col xs={7}>
              <Card className="me-2 px-2 pb-2">
                <Row className="d-flex justify-content-between">
                  <HrmsSearch
                    handleSearchChange={handleSearchChange}
                    placeholder="Leave Code"
                  />
                  {/* <Col
                    lg={"auto"}
                    onClick={() => handleFinacialCheck(finacialCheck)}
                    className=" d-flex align-items-center"
                  >
                    <input
                      type="checkbox"
                      className="ever-rise-checkbox"
                      name={"is_finacial_year"}
                      checked={finacialCheck}
                    />
                    <Label className="ms-2 mb-0">
                      FY {loggedUser?.finance?.replace(/\//g, "")}
                    </Label>
                  </Col> */}
                </Row>

                <hr className="table-divide" />
                <Row className="mt-2 ever-rise-table">
                  <Col xs={12}>
                  <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                    {listData?.data?.data && (
                      <UpdateTable
                        className="mt-5"
                        nodes={listData?.data?.data}
                        paginate={listData?.data}
                        columns={columns}
                        CurrentPage={page}
                        handlePagination={handlePaginate}
                        handleSizePerPage={handleSizePerPageChange}
                        tableWidth="20% 30% 20% 20% 10%"
                        isLoading={isLoadingNextPage}
                        hidePaginate={true}
                        position={true}
                      />
                    )}
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LeaveType
